import React from 'react';
import { Link } from 'react-router-dom';
function BusinessGoalOne() {
    return (
        <div>
            {/* business goal area */}
            <div className="rts-business-goal rts-section-gap" id='goal'>
                <div className="container">
                    <div className="row align-items-stretch">
                        {/* business goal left */}
                        <div className="col-lg-5 mb_md--30 mb_sm--30 d-flex h-100">
                            <div className="business-goal-one wow fadeInUp w-100 h-100 d-flex position-relative" data-wow-delay=".2s">
                                <picture><source srcSet="/assets/images/home/home-2.webp" type="image/webp" /><img className="w-100 h-100 flex-grow-1"
                                    src="/assets/images/home/home-2.png"
                                    alt="Business Goal"
                                    width="500"
                                    height="400"
                                    style={{ objectFit: 'cover', borderRadius: '16px' }}
                                    loading="lazy" /></picture>
                            </div>
                        </div>
                        {/* business goal right */}
                        <div className="col-lg-7">
                            <div className="business-goal-right wow fadeInRight" data-wow-delay=".4s">
                                <div className="rts-title-area business text-start pl--30">

                                    <h2 className="title">We manage business globally</h2>
                                </div>
                                <div className="rts-business-goal pl--30">
                                    <div className="single-goal">
                                        <img src="/assets/images/business-goal/icon/01.svg"
                                            alt="Custom AI Solutions Icon"
                                            className="thumb"
                                            width="48" height="48" loading="lazy" />
                                        <div className="goal-wrapper">
                                            <h6 className="title">Custom AI Solutions</h6>
                                            <p className="disc">
                                                We design and integrate tailored generative AI workflows that align perfectly with your unique operational and strategic goals.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="single-goal">
                                        <img src="/assets/images/business-goal/icon/02.svg"
                                            alt="Enterprise Scale Security Icon"
                                            className="thumb"
                                            width="48" height="48" loading="lazy" />
                                        <div className="goal-wrapper">
                                            <h6 className="title">Enterprise Scale & Security</h6>
                                            <p className="disc">
                                                Deploy intelligent applications securely across your entire organization with robust compliance, monitoring, and MLOps infrastructure.
                                            </p>
                                            <div className="goal-button-wrapper mt-4">
                                                <Link
                                                    to={'/contactus'}
                                                    className="vrm-blue-to-white-btn"
                                                >
                                                    Contact Us <i className="far fa-arrow-right ms-2" style={{ fontSize: '13px' }}></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* right area business ENd */}
                    </div>
                </div>
            </div>
            {/* business goal area End */}
        </div>
    )
}

export default BusinessGoalOne
